import { ShippingTypesGridView } from '~/components/order/shipping-types/grid';
import { PageContainer } from '~/components/page-container';

export function ShippingTypes() {
	return (
		<PageContainer>
			<ShippingTypesGridView />
		</PageContainer>
	);
}
